var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 10.0833C2.75 7.49059 2.75 6.19423 3.55546 5.38877C4.36091 4.58331 5.65727 4.58331 8.25 4.58331H10.0833C12.676 4.58331 13.9724 4.58331 14.7779 5.38877C15.5833 6.19423 15.5833 7.49059 15.5833 10.0833V14.6666C15.5833 17.2593 15.5833 18.5557 14.7779 19.3612C13.9724 20.1666 12.676 20.1666 10.0833 20.1666H8.25C5.65727 20.1666 4.36091 20.1666 3.55546 19.3612C2.75 18.5557 2.75 17.2593 2.75 14.6666V10.0833Z",
    stroke: "#423F5A",
    strokeWidth: 1.375
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37407 10.7819L7.72522 10.3628C8.39327 9.56535 8.72731 9.16669 9.16675 9.16669C9.6062 9.16669 9.94023 9.56535 10.6083 10.3628L10.9594 10.7819C11.5977 11.5436 11.9167 11.9246 11.9167 12.375C11.9167 12.8255 11.5977 13.2064 10.9594 13.9682L10.6083 14.3873C9.94023 15.1847 9.6062 15.5834 9.16675 15.5834C8.72731 15.5834 8.39327 15.1847 7.72522 14.3873L7.37407 13.9682C6.73586 13.2064 6.41675 12.8255 6.41675 12.375C6.41675 11.9246 6.73586 11.5436 7.37407 10.7819Z",
    stroke: "#423F5A",
    strokeWidth: 1.375
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5141 17.4166C16.5186 16.8551 16.8602 15.6205 17.5435 13.1513L18.5099 9.65936C19.1932 7.19011 19.5349 5.95551 18.9549 4.98289C18.3749 4.01026 17.0999 3.67945 14.5498 3.01783L12.7465 2.54999C10.1963 1.88837 8.92131 1.55756 7.9168 2.1191C7.20163 2.51891 6.82245 3.25989 6.41675 4.54469",
    stroke: "#423F5A",
    strokeWidth: 1.375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptions);
export default __webpack_public_path__ + "static/media/subscriptions.b7ffae7581ae3d4f0f8f1bd2b41c8d88.svg";
export { ForwardRef as ReactComponent };